import { z } from "zod";

export const editRecommendationSchema = z.object({
  text: z.string().nonempty("Required"),
});
